import {PlayPauseButton} from "../../base/PlayPauseButton";
import React from "react";
import {useBalance} from "../../base/hooks/useBalance";

interface Props {
    onStart: () => void;
    onStop: () => void;
}

export function SessionStartStopButton({ onStart, onStop }: Props) {
    const { isEnoughBalance, balanceLoading } = useBalance();

    return (
        <PlayPauseButton
            playText="Start Session"
            pauseText="Stop session"
            playClassName="flex items-center px-4 py-2 rounded-lg transition-colors bg-green-100 text-green-700 hover:bg-green-200"
            pauseClassName="flex items-center px-4 py-2 rounded-lg transition-colors bg-red-100 text-red-700 hover:bg-red-200"
            onStart={onStart}
            onStop={onStop}
            disabled={!isEnoughBalance || balanceLoading}
            disableReason={balanceLoading ? "Loading balance..." : "Not enough balance"}
        />
    );
}
